import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";

import {
  getCreateCourseDefaultFormData,
  getCreateCourseInitailStateForErrors,
  checkMinLength,
  isNumericInput,
  checkStartAndEndDate,
  buildSKUString,
} from "../helpers/helpers";

import {
  CourseBasicDetails,
  CourseBasicDetailsErrors,
  Package,
} from "../types/interfaces/CourseBasicDetails";
import { Goal } from "../types/interfaces/Goal";
import { User } from "../types/interfaces/User";
import DialogHeader from "../../userManagement/common/DialogHeader";
import DialogFooter from "../../userManagement/common/DialogFooter";

import {
  withStyles,
  WithStyles,
  Card,
  CardContent,
  CardActions,
  Checkbox,
  Typography,
  Modal,
  CardHeader,
  IconButton,
  Button,
  Grid,
  FormControl,
  FormControlLabel,
  FormGroup,
  Radio,
  Icon,
  Switch,
} from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import {
  MyPATTextField,
  MyPATDialog,
  MyPATSelect,
  dateService,
} from "../../common";
import CloseIcon from "@material-ui/icons/Close";
import { courseStyles } from "../styles";
import MyPATCalendar from "../../common/MyPATCalendar";
import Autocomplete from "../../common/Autocomplete";
import {
  getActiveGoals,
  getUserSuggestions,
  addCourseBasicDetails,
  addCourseTestSeries
} from "../actions/courseManagementActions";
import _ from "lodash";
import { DateCheck } from "../types/enums/DateCheckResults";
import SearchBarWithChips from "../common/SearchBarWithChips";
import ACLService from "../../acl/services/aclService";
import { onlyAllowNumbers } from "../../../utils";
import CreateCoursePopup from "./CreateCoursePopup/CreateCoursePopup";
import { CourseTypes } from "../types/enums/CourseTypes";
import courseManagementServices from "../service/courseManagementServices";
import { TestSeriesCoursePlan } from "../types/interfaces/CourseBasicDetails";
import { courseManagementActions } from "../reducers/courseManagementReducer";
import CourseDetail from "../../course/containers/CourseDetail";
import { isThisSecond } from "date-fns";
import { durationMap, getCourseDurationLabel } from "./CreateNewCourse/helper/getCourseDurationByDates";
interface TestSeriesBasicInfoProps {
  goals: Goal[];
  userSuggestions: User[];
  getActiveGoals: Function;
  getUserSuggestions: Function;
  addCourseBasicDetails: Function;
  classes: any;
  packageId: string;
  history: any;
  location: any;
  addCourseTestSeries: Function;
  packageData: Package;
  coursePlan: TestSeriesCoursePlan;
  basicDetails: CourseBasicDetails;
  isPreviewScreen: boolean
  minTestCount: number,
  setTestCount: Function,
  // minStartDate:string,
  setTestSeriesBasicInfo:Function
}

interface TestSeriesBasicInfoState {
  formData: CourseBasicDetails;
  formErrors: CourseBasicDetailsErrors;
  activateCreateCourseBtn: boolean;
  activeGoals: string[];
  userSuggestions: any[];
  loggedInUserFullName: string;
  clientId: string;
  selectedCourse: string;
  packageAdmins: any[],
  testCount: number,
  values: {value: string, label: string, id: string}[],
  shareViewRights:boolean,
  isMyPatClient:boolean,
  isTestSeries: boolean
}
class TestSeriesBasicInfo extends Component<
  TestSeriesBasicInfoProps,
  TestSeriesBasicInfoState
  > {
    userData = ACLService.getUserDetailsFromStorage();
    userId = this.userData.authenticatedUser.id;
    fullName = this.userData.authenticatedUser.fullName;
    //  clientID = this.userData.authenticatedUser.clients.map((c:any)=>{
    //   return c.id;
    // });
    clientId = this.userData.authenticatedUser.aclMetaData.clientId;
  constructor(props: TestSeriesBasicInfoProps) {
    super(props);
    const packageAdmins = _.get(this.props, "packageData.packageAdmins", []);
    const testCount = _.get(this.props, "coursePlan.testSeries.length", 1);
    this.state = {
      formData: {...this.props.basicDetails},
      formErrors: getCreateCourseInitailStateForErrors(),
      activateCreateCourseBtn: false,
      activeGoals: [],
      userSuggestions: [],
      loggedInUserFullName: "",
      clientId: "",
      selectedCourse: "",
      testCount: this.props.minTestCount,
      packageAdmins: this.prepareAdminNameSuggestions(packageAdmins),
      values:[],
      shareViewRights:false,
      isMyPatClient:false,
      isTestSeries: false
    };
  }

  componentDidMount() {
    this.props.getUserSuggestions({
      clientId: this.clientId,
    });
    const firstName = this.fullName.split(' ')[0];
    const lastName = this.fullName.split(' ')[1];
    const id = this.clientId;
    const packageAdmins = _.get(this.props, "packageData.packageAdmins", []);
    const { values } = this.state
    let updatedValues = this.modifyAdminData(packageAdmins)
    const {formData}=this.state;
    const newFormData={...formData};
    newFormData.testCount=this.props.minTestCount;
    newFormData.duration=this.props.basicDetails.duration;
    
    this.setState({
        loggedInUserFullName: this.fullName,
        clientId: this.userId,
        values: updatedValues,
        formData:newFormData,
        isMyPatClient:this.clientId=="5b5702e095cbc921944632a9"
    },()=>{this.updateUserSuggestions(); this.setCourseDuration()})
  }

  componentDidUpdate(prevProps: TestSeriesBasicInfoProps, prevState: TestSeriesBasicInfoState) {
    if (prevState.formData !== this.state.formData) {
      this.handleSubmit();
    }

    if (prevProps.goals !== this.props.goals) {
      this.setActiveGoals(this.props.goals);
    }

    if (prevProps.userSuggestions !== this.props.userSuggestions) {
      const fullNames = this.prepareAdminNameSuggestions(
        this.props.userSuggestions
      );
      this.setState({
        userSuggestions: fullNames,
      },()=>{this.updateUserSuggestions()});
    }
    if(prevState.testCount!==this.state.testCount&&this.state.testCount>this.props.minTestCount){
      this.props.setTestCount(this.state.testCount);
    }
  }

  setCourseDuration = () => {
    const  duration  = _.get(this.props, "packageData.duration", 0);
    const { formData } = this.state;
    let updatedFormData = {...formData};
    updatedFormData.duration = duration;
    this.setState({
      formData: updatedFormData
    })
  }

  modifyAdminData = (data: {firstName:string, lastName:string, id:string, isRemovable: boolean}[]) => {
    const preparedData = data.map(admin => ({
      value: `${admin.firstName} ${admin.lastName}`, 
      label: `${admin.firstName} ${admin.lastName}`, 
      id: admin.id, 
      isRemovable: admin.isRemovable
    }))
    return preparedData;
  }
  setActiveGoals = (goalData: Goal[]) => {
    if (goalData) {
      const goalNameArray = goalData.map((goal) => goal.name);
      this.setState({
        activeGoals: goalNameArray,
      });
    }
  };

  validateFormData = (field: string, data?: any) => {
    const { formData, formErrors } = this.state;
    const {
      name,
      sku: { SKUText, SKUNumber, SKUYear },
      courseDetails,
      startDate,
      endDate,
      packageAdmins,
    } = formData;

    switch (field) {
      case "name":
        formErrors.name = checkMinLength(name, 5)
          ? ""
          : "Enter atleast 5 characters";
        break;
      case "sku.SKUText":
        formErrors.sku.SKUText = checkMinLength(SKUText, 3)
          ? ""
          : "Enter atleast 3 characters";
        break;
      case "sku.SKUNumber":
        formErrors.sku.SKUNumber = checkMinLength(SKUNumber.toString(), 1)
          ? ""
          : "Enter atleast 1 character";
        break;
      case "date":
        const dateCheckResult = checkStartAndEndDate(
          startDate.value,
          endDate.value
        );
        switch (dateCheckResult) {
          case DateCheck.startGreaterThanEnd:
            formErrors.startDate = DateCheck.startGreaterThanEnd;
            break;
          case DateCheck.endLessThanStart:
            formErrors.endDate = DateCheck.endLessThanStart;
            break;
          default:
            formErrors.startDate = "";
            formErrors.endDate = "";
        }
        break;
      case "goal":
        formErrors.courseDetails =
          courseDetails.length > 0 ? "" : "Select a goal";
        break;
      case "courseAdmins":
        formErrors.packageAdmins =
          data !== null ? "" : "Select atleast one course admin";
        break;
      default:
    }

    this.setState({
      formErrors: formErrors,
    });
  };
  validateEmptyStrings = (formErrors: CourseBasicDetailsErrors) => {
    const { name, sku, courseDetails, startDate, endDate, packageAdmins } = formErrors
    return name === "" && sku.SKUText === "" && sku.SKUNumber === ""
      && courseDetails === "" && startDate === "" &&
      endDate === "" && packageAdmins === ""
  }
  canActivateCreateCourseBtn = () => {
    const { formErrors } = this.state;
    let activateCreateCourseBtn = false;

    if (this.validateEmptyStrings(formErrors)) {
      activateCreateCourseBtn = true;
    } else {
      activateCreateCourseBtn = false;
    }

    this.setState({
      activateCreateCourseBtn: activateCreateCourseBtn,
    });
  };

  handleChange = (event: any) => {
    const { name, value } = event.target;
    const updatedFormData = { ...this.state.formData };
    const updatedFormErrors = this.state.formErrors;
    switch (name) {
      case "name":
        updatedFormData.name = value;
        if (updatedFormErrors.name === "untouched") {
          updatedFormErrors.name = "";
        }
        this.validateFormData("name");
        break;
      case "skuText":
        updatedFormData.sku={...updatedFormData.sku,SKUText : value};
        if (updatedFormErrors.sku.SKUText === "untouched") {
          updatedFormErrors.sku.SKUText = "";
        }
        this.validateFormData("sku.SKUText");
        break;
      case "skuNumber":
        updatedFormData.sku={...updatedFormData.sku,SKUNumber:value.replace(/[^\w\s]/gi, "")};
        if (updatedFormErrors.sku.SKUNumber === "untouched") {
          updatedFormErrors.sku.SKUNumber = "";
        }
        this.validateFormData("sku.SKUNumber");
        break;
      // case "goal":
      //   updatedFormData.courseDetails = value;
      //   const SKUYear = value.split("-");
      //   updatedFormData.sku.SKUYear = SKUYear[SKUYear.length - 1];
      //   if (updatedFormErrors.courseDetails === "untouched") {
      //     updatedFormErrors.courseDetails = "";
      //   }
      //   this.validateFormData("goal");
      //   break;
      case "CourseCreated":
        this.setState({
          selectedCourse: value,
        });
        break;
      case 'courseDuration':
        updatedFormData.duration = +value;
        
        break;
      default:
    }
    this.setState(
      {
        formData: updatedFormData,
        formErrors: updatedFormErrors,
      }
      // () => {
      //   this.canActivateCreateCourseBtn();
      // }
    );
  };

  handleDateSelection = (date: any, type: string) => {
    const updatedFormData = { ...this.state.formData };
    const updatedFormErrors = this.state.formErrors;
    const formattedDate = dateService.dateOnly(date);
    let resultDate={label:formattedDate,value:date};
    let newDate = new Date(date);
    switch (type) {
      case "startDate":
        updatedFormData.startDate=resultDate;
        updatedFormErrors.startDate = "";
        this.validateFormData("date");
        break;
      case "endDate":
        newDate.setHours(23, 59, 59,0);
        resultDate.value = newDate.toISOString();
        updatedFormData.endDate = resultDate;
        updatedFormErrors.endDate = "";
        this.validateFormData("date");
        break;
      default:
    }
    this.setState(
      {
        formData: updatedFormData,
        formErrors: updatedFormErrors,
      }
      // () => {
      //   this.canActivateCreateCourseBtn();
      // }
    );
  };



  renderSelectGoalOptions = () => {
    let options = [];
    options.push(<option value={""}>{"Select Goal"}</option>);
    _.map(this.state.activeGoals, (goal: string, index: number) =>
      options.push(
        <option key={index} value={goal}>
          {goal}
        </option>
      )
    );
    return options;
  };

  prepareAdminNameSuggestions = (data: User[]) => {
    // {label: 'Adam'}
    let users = data
      .map((user) => {
        if (user.firstName !== undefined && user.firstName !== null)
          return user;
      })
      .filter((user) => user !== undefined)
      .map((user) => ({
        id: user && _.get(user, 'id', user._id),
        label: `${user && user.firstName} ${user &&
          user.lastName !== null &&
          user.lastName !== undefined &&
          user.lastName}`,
      }));

    return users;
  };
  updateUserSuggestions = () => {
    this.setState({isTestSeries: this.state.formData.subType === 'previous-year' ? true: false});
    const { userSuggestions: allUserSuggestions } = this.props;
    const { formData, userSuggestions, values } = this.state;
    const { packageAdmins } = formData;
    let updatedUserSuggestions:any = [];
    allUserSuggestions.forEach((user) => {
        let addCurrentUser = true;
        const fullName = `${user.firstName} ${user.lastName}`
        values.forEach((admin) => {
            // const adminFullName = `${admin.firstName} ${admin.lastName}`
            if(fullName === admin.label){
                addCurrentUser = false;
            }
        })
        if(addCurrentUser){
            updatedUserSuggestions.push({id:user._id, label: fullName})
        }
        
    })
    this.setState({
        userSuggestions: updatedUserSuggestions,
    })
  }

  handleCourseAdminNames = (
    names: { value: string; label: string; id: string }[]
) => {
     this.validateFormData('courseAdmins', names);
    if (names !== null) {
        this.updateUserSuggestions();
        const{userSuggestions}=this.props;
        const admins = names.filter((name) => name.id);
        console.log(admins);
        let selectedAdmins: any = [];
        admins.forEach((admin) => {
            const currentUser = userSuggestions.filter((user) => user._id === admin.id);
            console.log({currentUser});
            selectedAdmins.push(currentUser[0]);
        });
        console.log(selectedAdmins)
        const trimmedAdminObjects = selectedAdmins.map((admin: User) => ({
            id: admin._id,
            firstName: admin.firstName,
            lastName: admin.lastName,
            isRemovable: this.state.loggedInUserFullName.toString().includes(`${admin.firstName}`) ?  false : true,
        }));
        console.log(trimmedAdminObjects);

        let updatedValues = trimmedAdminObjects.map((admin: any) => ({
            label: `${admin.firstName} ${admin.lastName}`,
            value: `${admin.firstName} ${admin.lastName}`,
            id: admin.id,
            isRemovable: this.state.loggedInUserFullName.toString().includes(`${admin.firstName}`) ?  false : true
        }))
        console.log('UPDATED VALUES--------->', updatedValues)


        this.canActivateCreateCourseBtn();
        this.setState((prevState:any)=>{
            let { formData } = prevState;
            let { packageAdmins } = formData;
            
            let updatedFormData = {...formData}
            let updatedPackageAdmins = [...trimmedAdminObjects]

            // packageAdmins = trimmedAdminObjects;
            updatedFormData.packageAdmins = updatedPackageAdmins;
            return {
                formData: updatedFormData,
                values: updatedValues
            };
         },
            () => {
                console.log(this.state.formData);
                // this.canActivateCreateCourseBtn();
                this.updateUserSuggestions();
            }
        );
    } else {
        console.log('IN Handle Admin NAmes ELSE---------')
        let { formData } = this.state;
        let { packageAdmins } = formData;
        let updatedFormData = {...formData}
        let updatedPackageAdmins = [...packageAdmins]
        // updatedPackageAdmins = [];
        updatedFormData.packageAdmins = updatedPackageAdmins;
        this.setState({
            formData: updatedFormData
        }, () => this.canActivateCreateCourseBtn())
    }
};
  prepareCourseDetailArray = () => {
    const goal = this.props.goals.filter(
      (goal) => goal.name === this.state.formData.courseDetails
    );
    const goalData = [
      {
        courseId: goal[0]._id,
        courseType: goal[0].courseType,
        courseName: goal[0].name,
      },
    ];
    return goalData;
  };
  checkForEmptyAndUnTouch = (object: any, path: string) => {
    const result = _.get(object, path, '');
    return result !== "" && result !== "untouched" ? true : false
  }
  handleSubmit = () => {
    const { formData } = this.state;
    this.props.setTestSeriesBasicInfo(formData);
  };
  handleSelectedCourses = () => { };
  handleTestCount = (event: any) => {
    if(event.target.value>999)
       return ;
    const { testCount,formData } = this.state;
     const updatedFormData={...formData};
     updatedFormData.testCount=event.target.value;
    this.setState({testCount:event.target.value,formData:updatedFormData});
  }
 
  prepareMultiDataForSuggestionChip = (courseDetails: any) => {
    let courseDetailFormatAccToSuggestionChip: any = []
    courseDetails.forEach((course: any) => {
      const refinedCourseData = {
        value: course && course.courseName,
        id: course && course._id,
        label: course && course.courseName,
      }
      courseDetailFormatAccToSuggestionChip.push(refinedCourseData);
    });
    return courseDetailFormatAccToSuggestionChip
  }
 
  getCourseDurationOptions = () => {
    let options = [];
    options.push(<option value={0}>{'Select Course Duration'}</option>);
    _.map(durationMap, (duration: {label: string, value: number}, index: number) =>
          options.push(
            <option key={index} value={duration.value}>
                {duration.label}
            </option>
        )
    );
    return options;
  }
  setShareEditKey=()=>{
    const {formData } = this.state;
    const updatedFormData={...formData};
    updatedFormData.isSharedWithFiitjeeClients=!updatedFormData.isSharedWithFiitjeeClients;
   this.setState({formData:updatedFormData});
  }
  setIsTestSeries=()=>{
    this.setState({isTestSeries: !this.state.isTestSeries}, () => {
      const {formData } = this.state;
      const updatedFormData={...formData};
      updatedFormData.subType = this.state.isTestSeries ? 'previous-year': '';
      this.setState({formData:updatedFormData});
    });
  }
  render() {
    const { classes, isPreviewScreen, minTestCount,packageData, basicDetails} = this.props;
    const { formData, formErrors, packageAdmins,testCount, isTestSeries  } = this.state;
    let startDate = _.get(formData, "startDate.value", '');
    startDate = new Date(startDate);
    // let endDate = _.get(formData, "endDate.value", '');
    // endDate = new Date(endDate);
    let minEndDate=_.get(packageData,"expiryDate",startDate);
    let adminsNames = packageAdmins.map((admin: any) => {
      return admin.label;
    }).join(', ');
    const courseAdmins=_.get(formData ,"courseDetails",[]);
    let courseNames=courseAdmins.map((courseDetail:any)=>{
          return courseDetail.courseName
    }).join(', ');
    let courseSKU = _.get(packageData, 'sku', '')
    const status=_.get(packageData,'status','DRAFT');
    const subType= _.get(packageData,'subType','');
    return (
      <div>
        <Card elevation={0} className={classes.customDialogHeader}>
          <DialogHeader
            urlName="/course-management"
            headerTitle={isPreviewScreen ? "Basic Info" : "Edit Basic Info"}
          />
          {!isPreviewScreen ? <CardContent className={classes.cardContentStyle}>
            {/* <Grid container justify="flex-start">
              <Grid item xs={8}>
                <Typography className={classes.cardHeading}>Course Basic Detail<span>*</span> </Typography>
              </Grid>
            </Grid> */}
            <Grid container spacing={8} justify="flex-start">
              <Grid item xs={8}>
                <Grid container spacing={8}>
                  <Grid item xs={6}>
                    <Typography className={classes.inputLable}>
                      Course Name
                      </Typography>
                    <MyPATTextField
                      //   className={classes.inputWidth}
                      fullWidthControl
                      inputId="name"
                      name="name"
                      placeholder="Course Name"
                      // disabled={actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY}
                      value={this.state.formData.name || ""}
                      onChange={this.handleChange.bind(this)}
                      error={
                        this.checkForEmptyAndUnTouch(formErrors, "name")
                      }
                      errorText={this.state.formErrors.name}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography className={classes.inputLable}>SKU</Typography>
                    <Grid container spacing={8}>
                      <Grid item xs={6}>
                        <MyPATTextField
                          //   className={classes.inputWidth}
                          fullWidthControl
                          inputId="skuText"
                          name="skuText"
                          placeholder="E.g. JEE"
                          disabled={status.toUpperCase()!='DRAFT'}
                          value={this.state.formData.sku.SKUText || ""}
                          onChange={this.handleChange.bind(this)}
                          error={
                            this.checkForEmptyAndUnTouch(formErrors, "sku.SKUText")
                          }
                          errorText={this.state.formErrors.sku.SKUText}
                        />
                        <span className={classes.smallInfo}>Atleast 3 characters </span>
                      </Grid>

                      <Grid item xs={6}>
                        <MyPATTextField
                          //   className={classes.inputWidth}
                          fullWidthControl
                          inputId="skuNumber"
                          name="skuNumber"
                          placeholder="01"
                          disabled={status.toUpperCase()!='DRAFT'}
                          value={this.state.formData.sku.SKUNumber || ""}
                          onChange={this.handleChange.bind(this)}
                          error={
                            this.checkForEmptyAndUnTouch(formErrors, "sku.SKUNumber")
                          }
                          errorText={this.state.formErrors.sku.SKUNumber}
                          onKeyPress={onlyAllowNumbers}
                        />
                        <span className={classes.smallInfo}>Value must be numeric </span>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {/* Select goal and start and end date */}
            <Grid container spacing={8} justify="flex-start" className={classes.mt30}>
              <Grid item xs={8}>
                <Grid container justify="flex-start" spacing={8}>
                  <Grid item xs={6}>
                    <Typography className={classes.inputLable}>Goal</Typography>
                    {/* <MyPATSelect
                      value={this.state.formData.courseDetails}
                      name="goal"
                      onChange={(e: any) => this.handleChange(e)}
                      disabled={true}
                    >
                      {this.renderSelectGoalOptions()}
                    </MyPATSelect> */}
                    <SearchBarWithChips
                      suggestions = {[]}
                      disabled={true}
                      placeholderText='Select Goal'
                      classes={{ root: classes.searchBarChips }}
                      values={this.prepareMultiDataForSuggestionChip(this.state.formData.courseDetails)}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Grid container spacing={16}>
                      <Grid item xs={6} className={classes.customCalendar}>
                        <Typography className={classes.inputLable}>Start Date </Typography>
                        <MyPATCalendar
                          fullWidthControl
                          onChange={(dateVal: string) =>
                            this.handleDateSelection(dateVal, 'startDate')
                          }
                          date={this.state.formData.startDate.label}
                          placeholder="Select Start Date"
                          disabled={true}
                        />
                      </Grid>
                      <Grid item xs={6} className={classes.customCalendar}>
                        <Typography className={classes.inputLable}>End Date</Typography>
                        <MyPATCalendar
                          fullWidthControl
                          onChange={(dateVal: string) =>
                            this.handleDateSelection(dateVal, 'endDate')
                          }
                          date={this.state.formData.endDate.label}
                          placeholder="Select End Date"
                          minDate={minEndDate}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
               
                </Grid>
              </Grid>
            </Grid>


            <Grid container spacing={8} justify="flex-start" className={classes.mt30}>
              <Grid item xs={8}>
                <Grid container spacing={8}>
                  <Grid item xs={6}>
                    <Typography className={classes.inputLable}>
                      Test Count
                    </Typography>
                    <MyPATTextField
                      //   className={classes.inputWidth}
                      fullWidthControl
                      inputId="testCount"
                      name="testCount"
                      // placeholder=""
                      // disabled={actionType === GOAL_ACTION_TYPE_CONST.READ_ONLY}
                      value={testCount}
                      onChange={this.handleTestCount.bind(this)}
                      onKeyPress={onlyAllowNumbers}
                      required
                    />
                    <span className={classes.smallInfo}>Test Count should be atleast {minTestCount} </span>
                  </Grid>

                  <Grid item xs={6}>
                          <Grid item xs={6}>
                          <Typography
                            className={[
                              classes.inputLable,
                              classes.mb0,
                            ].join(" ")}
                          >
                            Course Duration
                          </Typography>
                        </Grid>
                       <Grid item xs={6} className={classes.mb30} style={{marginTop: '10px'}}> 
                         <MyPATSelect
                            value={this.state.formData.duration}
                            name="courseDuration"
                            onChange={(e: any) => this.handleChange(e)}
                          >
                            {this.getCourseDurationOptions()}
                          </MyPATSelect>
                          </Grid>
                  </Grid>

                  <Grid item xs={6}>
                    <Typography className={classes.inputLable}>
                        Course Admin
                    </Typography>
                     <SearchBarWithChips
                            suggestions={this.state.userSuggestions}
                            placeholderText="Select Course Admins"
                            onSelection={this.handleCourseAdminNames}
                            // loggedInUserFullName={this.state.loggedInUserFullName}
                            classes={{root: classes.searchBarChips}}
                            notFound='No User Found'
                            values={this.state.values}
                            isClearable={false}
                            backspaceRemoves={false}
                        />
                  </Grid>
                  <Grid item xs={6}>
                    <Typography className={classes.inputLable}>
                      Test Series Type
                    </Typography>
                    <FormControlLabel
                      className={classes.updateLabel}
                      control={
                        <Switch
                          classes={{
                            root: classes.swithMain,
                            icon: classes.switchIcon,
                            bar: classes.switchBar,
                            iconChecked: classes.IscheckedSwitch,
                            checked: classes.checkedSwitch,
                          }}
                          color="primary"
                          checked={
                            isTestSeries
                          }
                          onChange={() =>
                            this.setIsTestSeries()
                          }
                        />
                      }
                      label="Previous Year Tests Series"
                      labelPlacement="start"
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {this.state.isMyPatClient &&
                     <> 
                      <Grid item xs={6}>
                        <Typography
                          style={{marginTop: '20px'}}
                          className={[
                            classes.inputLable,
                            classes.mb0,
                          ].join(" ")}
                        >
                          Share Course(with view and copy rights)
                        </Typography>
                      </Grid>

                      <Grid item xs={6}>
                        <FormControlLabel
                          className={classes.updateLabel}
                          control={
                            <Switch
                              classes={{
                                root: classes.swithMain,
                                icon: classes.switchIcon,
                                bar: classes.switchBar,
                                iconChecked: classes.IscheckedSwitch,
                                checked: classes.checkedSwitch,
                              }}
                              color="primary"
                              checked={
                                formData.isSharedWithFiitjeeClients
                              }
                              onChange={() =>
                                this.setShareEditKey()
                              }
                            />
                          }
                          label="Share this course with FIITJEE Clients?"
                          labelPlacement="start"
                        />
                      </Grid>
                      </>}
                    
          </CardContent> :
            <CardContent>
              {<Grid>
                 <Grid className={classes.basicInfoHeading}>{formData.name}</Grid>
               <Grid className={classes.basicInfoText}>Goal(s)&nbsp;:&nbsp;{courseNames}</Grid>
               <Grid className={classes.basicInfoText}>SKU&nbsp;:&nbsp;{courseSKU}</Grid>
                <Grid className={classes.basicInfoText}>Course Interval&nbsp;:&nbsp;{formData.startDate.label} to {formData.endDate.label}</Grid>
              <Grid className={classes.basicInfoText}>Admins&nbsp;:&nbsp;{adminsNames}</Grid>
                <Grid className={classes.basicInfoText}>Test Count&nbsp;:&nbsp;{testCount}</Grid> 
                <Grid className={classes.basicInfoText}>Course Duration&nbsp;:&nbsp;{getCourseDurationLabel(basicDetails)}</Grid>
                { subType != '' ? <Grid className={classes.basicInfoText}>Test Series Type&nbsp;:&nbsp;Previous Year</Grid> : <></>} 
              </Grid>}
            </CardContent>}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  goals: state.courseMangementData.courseManagementReducer.activeGoals,
  userSuggestions:
    state.courseMangementData.courseManagementReducer.userSuggestions,
  packageId: state.courseMangementData.courseManagementReducer.testSeries.packageId,
  minTestCount: state.courseMangementData.courseManagementReducer.testSeries.testCount,
  minStartDate: state.courseMangementData.courseManagementReducer.testSeries.minStartDate,
  basicDetails: state.courseMangementData.courseManagementReducer.testSeries.basicDetail,
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      getActiveGoals: getActiveGoals,
      getUserSuggestions: getUserSuggestions,
      addCourseBasicDetails: addCourseBasicDetails,
      addCourseTestSeries: addCourseTestSeries,
      setTestCount: courseManagementActions.setTestCount,
      setTestSeriesBasicInfo:courseManagementActions.setTestSeriesBasicInfo
    },
    dispatch
  );

// @ts-ignore
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(courseStyles)(withRouter(TestSeriesBasicInfo)));
